const setAnchorTagsToOpenInNewTab = (html: string) =>
  html.replace(
    /<a\b(?![^>]*\btarget=)/gi,
    '<a target="_blank" rel="noopener noreferrer"',
  );

export default setAnchorTagsToOpenInNewTab;
